export default "__VITE_ASSET__BOc4VfGt__"